module.exports = __webpack_public_path__ + "static/img/00_intro.22c744d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/00_intro.png
// module id = vQeW
// module chunks = 1